import type { PlayerColor } from './types';

// I18N_START
const TRANSLATIONS = {
  en: {
    player_blue: "Blue",
    player_green: "Green",
    player_red: "You",
    player_wins: "{name} Wins!",
    player_yellow: "Yellow",
    restart_game: "Restart",
    resume: "Resume",
    tap_to_play: "Tap to play again",
    tap_to_roll: "tap to roll",
    tap_to_start: "Tap to start",
    to_hub: "Home",
    you_win: "You Win!",
  },
  hi: {
    player_blue: "नीला",
    player_green: "हरा",
    player_red: "आप",
    player_wins: "{name} जीते!",
    player_yellow: "पीला",
    restart_game: "फिर से",
    resume: "जारी रखें",
    tap_to_play: "फिर से खेलने के लिए टैप करें",
    tap_to_roll: "टैप करें",
    tap_to_start: "शुरू करने के लिए टैप करें",
    to_hub: "मुख्य",
    you_win: "आप जीते!",
  },
  ru: {
    player_blue: "Синий",
    player_green: "Зелёный",
    player_red: "Вы",
    player_wins: "Победил {name}!",
    player_yellow: "Жёлтый",
    restart_game: "Заново",
    resume: "Продолжить",
    tap_to_play: "Нажмите чтобы сыграть снова",
    tap_to_roll: "нажмите",
    tap_to_start: "Нажмите чтобы начать",
    to_hub: "В хаб",
    you_win: "Вы победили!",
  },
} as const;
// I18N_END

type Lang = keyof typeof TRANSLATIONS;
type Key  = keyof typeof TRANSLATIONS['ru'];
type Params = Record<string, string | number>;

const _lang = (localStorage.getItem('lang') ?? navigator.language.slice(0, 2)) as Lang;
const _L    = TRANSLATIONS[_lang in TRANSLATIONS ? _lang : 'ru'];

export function t(key: Key, params?: Params): string {
  let s: string = _L[key] ?? TRANSLATIONS['ru'][key];
  if (params) for (const k in params) s = s.replace(`{${k}}`, String(params[k]));
  return s;
}

export function playerName(color: PlayerColor): string {
  return t(`player_${color}` as Key);
}
